import isNil from 'lodash/isNil';
import reduce from 'lodash/reduce';

import { DEFAULT_GRID_TAXONOMY } from 'grid_taxonomy.js';
import { isGridPositionsContentSection } from 'zoomforth_codesbane_viewer/lib/sections.js';

const sanitizeSection = (section)=> {
  const newSection = { ...section };

  if (isGridPositionsContentSection(section) && isNil(newSection.gridTaxonomy)) {
    newSection.gridTaxonomy = DEFAULT_GRID_TAXONOMY;
  }

  return newSection;
};

export default (sectionsById)=> {
  return reduce(sectionsById, (accum, section, sectionId)=> {
    return {
      ...accum,
      [sectionId]: sanitizeSection(section)
    };
  }, {});
};
